import { Box, Typography } from "@mui/material"
import { UserDetailsWrapper } from "./Atom"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { StyledTab } from "./Atom"

import GroupDetailsTab from "./GroupDetailsTab"
import { useSelector } from "react-redux"

function UserDetails(props: any) {
  const { fetchUserDetails } = props
  const userProfileData = useSelector(
    (state: any) => state.user?.userProfileData,
  )

  return (
    <>
      <UserDetailsWrapper>
        {userProfileData?.basic_details?.role_category !== "admin" ? (
          <Box
            sx={{
              "& .MuiTabPanel-root": {
                padding: "0px",
              },
              display: "flex",
              height: "100%",
              flexDirection: "column",
            }}
          >
            <TabContext value={"1"}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  height: "10%",
                }}
              >
                <TabList
                  aria-label="Tabs"
                  // onChange={handleChangeTab}
                  TabIndicatorProps={{
                    sx: { maxWidth: "34px", height: "4px" },
                  }}
                >
                  <StyledTab label="Group Details" value="1" disableRipple />
                </TabList>
              </Box>

              <TabPanel value="1" sx={{ flex: 1 }}>
                <GroupDetailsTab fetchUserDetails={fetchUserDetails} />
              </TabPanel>
            </TabContext>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography>Administrator has all access.</Typography>
          </Box>
        )}
      </UserDetailsWrapper>
    </>
  )
}
export default UserDetails
